import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import Container from '@/components/Container';
import useResetPassword from '../useResetPassword';
import FieldError from '@/components/FieldError';
import { Link } from 'react-router-dom';

const ResetPassword = () => {
  const { forgotPasswordPage, registerResetPassword, handleSubmitResetPassword, errors, isLoading } =
    useResetPassword();

  if (!forgotPasswordPage) return null;

  return (
    <Container className="h-full">
      <div className="col-span-12 flex min-h-0 items-center justify-center py-4">
        <div className="flex max-h-[90dvh] w-full max-w-[416px] flex-col items-start overflow-auto rounded-2xl bg-white p-8 shadow-lg">
          <img
            className="mb-4 h-auto w-[100px] self-start"
            src={forgotPasswordPage?.pageImage.data?.attributes?.url}
            alt={forgotPasswordPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
          />
          <div className=" flex flex-col items-start">
            <h2 className=" mb-4 text-center font-haffer text-sh-28-32 font-bold leading-9 tracking-tight text-gray-900">
              {forgotPasswordPage?.chooseANewPasswordTitle}
            </h2>

            <p className=" mb-3 font-haffer text-sh-xs">{forgotPasswordPage?.passwordsShouldBeDescription}</p>

            <form onSubmit={handleSubmitResetPassword} className="w-full">
              <div className=" mb-4 w-full">
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{forgotPasswordPage?.yourNewPassword}</p>
                </Label>
                <Input
                  placeholder={forgotPasswordPage?.yourNewPassword}
                  type="password"
                  {...registerResetPassword('password')}
                />
                <FieldError message={errors?.password?.message} />
              </div>

              <div className=" mb-8 w-full">
                <Label>
                  <p className="mb-2 font-haffer text-sh-xs">{forgotPasswordPage?.repeatYourPassword}</p>
                </Label>
                <Input
                  placeholder={forgotPasswordPage?.repeatYourPassword}
                  type="password"
                  {...registerResetPassword('confirmPassword')}
                />
                <FieldError message={errors?.confirmPassword?.message} />
              </div>

              <Button type="submit" theme="solid" className=" mb-4" loading={isLoading}>
                {forgotPasswordPage?.resetMyPasswordCta}
              </Button>
            </form>

            <Link
              className="text-center font-haffer text-sh-xs font-bold text-people-teal-600 hover:!text-people-blue-600"
              to="/login">
              {forgotPasswordPage?.backToLoginCta}
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ResetPassword;
